const __WEBPACK_NAMESPACE_OBJECT__ = require("perf_hooks");